module.exports = __webpack_public_path__ + "d50faa441d0cf9e9de90d25c2249eda8.fbx";